// tslint:disable:max-line-length
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TranslationService } from '../services/translation.service';
import { AppTranslations } from '../translations/app-module.translations';
import { TranslationConstants } from '../constants/translations.constats';
import { UsersModuleTranslations } from '../translations/users-module.translations';
import { NameValuePair } from '../models/NameValuePair.models';
import { QuoteModuleTranslations } from '../translations/quote-module.translations';
import { ProductModuleTranslations } from '../translations/product-module.translations';
import { ProvidersModuleTranslations } from '../translations/providers-module.translations';
import { PricingCalculationsModuleTranslations } from '../translations/pricing-calculations-module.translations';
import { SetupHomeModuleTranslations } from '../translations/setup-home-module.translations';
import { SalesAreaModuleTranslations } from '../translations/sales-area-module.translations';
import { SecurityModuleTranslations } from '../translations/security-module.translations';
import { AuditTrailModuleTranslations } from '../translations/audit-trail-module.translations';
import { UiDesignModuleTranslations } from '../translations/ui-design-module.translations';
import { BusinessPartnersModuleTranslations } from '../translations/business-partners-module.translations';
import { DeveloperToolsModuleTranslations } from '../translations/developer-tools-module.translations';
import { DevelopModuleTranslations } from '../translations/develop-module.translations';
import { ImportExportModuleTranslations } from '../translations/import-export-module.translations';
import { GeneralModuleTranslations } from '../translations/general-module.translations';
import { WorkflowApprovalModuleTranslations } from '../translations/workflow-approval-module.translations';

@Injectable()
export class TranslationsResolverService  {
    constructor(
        private route: ActivatedRoute,
        private http: HttpClient,
        public translationService: TranslationService
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        if (!this.isModuleTranslated(route.data['path'])) {
            let keys: Array<string>;
            switch (route.data['path']) {
                case '':
                    keys = AppTranslations;
                    break;
                case 'setup-home':
                    keys = SetupHomeModuleTranslations;
                    break;
                case 'users':
                    keys = UsersModuleTranslations;
                    break;
                case 'quote':
                    keys = QuoteModuleTranslations;
                    break;
                case 'products':
                    keys = ProductModuleTranslations;
                    break;
                case 'security':
                    keys = SecurityModuleTranslations;
                    break;
                case 'providers':
                    keys = ProvidersModuleTranslations;
                    break;
                case 'pricing-calculations':
                    keys = PricingCalculationsModuleTranslations;
                    break;
                case 'audit-trail':
                    keys = AuditTrailModuleTranslations;
                    break;
                case 'ui-design':
                    keys = UiDesignModuleTranslations;
                    break;
                case 'business-partners':
                    keys = BusinessPartnersModuleTranslations;
                    break;
                case 'developer-tools':
                    keys = DeveloperToolsModuleTranslations;
                    break;
                case 'develop':
                    keys = DevelopModuleTranslations;
                    break;
                case 'import-export':
                    keys = ImportExportModuleTranslations;
                    break;
                case 'general':
                    keys = GeneralModuleTranslations;
                    break;
                case 'workflow-approval' :
                    keys = WorkflowApprovalModuleTranslations;
                    break;
                case 'sales-area':
                    keys = SalesAreaModuleTranslations;
                    break;                    
                case '404':
                    keys = ['Error404.Message'];
                    break;
                default:
                    alert('path in app.routes.ts is not provided');
            }
            return this.translationService
                .translateModule(keys)
                .then(translations => {
                    const temp: Array<NameValuePair> = JSON.parse(localStorage.getItem(TranslationConstants.TRANSLATIONS)) || [];
                    localStorage.setItem(TranslationConstants.TRANSLATIONS, JSON.stringify(temp.concat(translations)));

                    const list = JSON.parse(localStorage.getItem(TranslationConstants.LIST_OF_TRANSLATED_MODULES)) || {};
                    list[route.data['path']] = true;
                    localStorage.setItem(TranslationConstants.LIST_OF_TRANSLATED_MODULES, JSON.stringify(list));
                    return;
                });
        }
    }

    private isModuleTranslated(modulePath: string) {
        return localStorage.getItem(TranslationConstants.LIST_OF_TRANSLATED_MODULES)
            && JSON.parse(localStorage.getItem(TranslationConstants.LIST_OF_TRANSLATED_MODULES))[modulePath];
    }
}
